import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=0abdeae4&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=0abdeae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abdeae4",
  null
  
)

export default component.exports